import { render, staticRenderFns } from "./userAndDeptCascader.vue?vue&type=template&id=1b8cf583&scoped=true&"
import script from "./userAndDeptCascader.vue?vue&type=script&lang=js&"
export * from "./userAndDeptCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8cf583",
  null
  
)

export default component.exports